import { ApiService } from "../..";

export const logout = () => {
  return ApiService.baseAction("auth/logout", {}, "post");
};
